import { useState } from 'react';
import { motion } from 'motion/react';
import { Database, CheckCircle, AlertCircle, RefreshCw } from 'lucide-react';

export const DatabaseCheck = () => {
  const [isChecking, setIsChecking] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleCheck = () => {
    setIsChecking(true);
    setStatus('idle');
    // Simulate check
    setTimeout(() => {
      setIsChecking(false);
      setStatus('success');
    }, 2000);
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 overflow-hidden">
      <div className="p-6 border-b border-slate-100 dark:border-slate-700/50">
        <h3 className="font-bold text-xl text-slate-800 dark:text-white">بررسی سلامت دیتابیس</h3>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">با استفاده از این بخش می‌توانید وضعیت جداول و ارتباط دیتابیس را بررسی کنید.</p>
      </div>
      
      <div className="p-8 flex flex-col items-center justify-center min-h-[300px]">
        <Database size={64} className="text-slate-300 dark:text-slate-600 mb-6" />
        
        {status === 'success' && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="mb-8 p-4 bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-200 dark:border-emerald-500/30 rounded-xl flex items-center gap-3 text-emerald-700 dark:text-emerald-400 w-full max-w-md"
          >
            <CheckCircle size={24} className="shrink-0" />
            <div>
              <p className="font-bold">بررسی با موفقیت انجام شد</p>
              <p className="text-sm mt-1">تمام جداول به درستی کار می‌کنند و ارتباط با دیتابیس برقرار است.</p>
            </div>
          </motion.div>
        )}

        <button 
          onClick={handleCheck}
          disabled={isChecking}
          className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-6 py-3 rounded-xl font-medium flex items-center gap-3 transition-colors shadow-lg shadow-blue-500/30"
        >
          {isChecking ? (
            <RefreshCw size={20} className="animate-spin" />
          ) : (
            <CheckCircle size={20} />
          )}
          <span>{isChecking ? 'در حال بررسی...' : 'شروع بررسی دیتابیس'}</span>
        </button>
      </div>
    </div>
  );
};
